/**
 * Chat GIF playback: auto-play this many full loops when using video, then pause until Play is pressed.
 */
export const CHAT_GIF_AUTOPLAY_LOOPS = 5;
